define.alias("ember-power-select/components/power-select/label", "calendar/components/power-select/label");